 document.addEventListener('DOMContentLoaded', () => {
  const init = (root) => {
    if (!root) return;

    // ✅ Swiper公式の初期化済みクラスで確実に二重起動防止
    if (root.classList.contains('swiper-initialized')) return;

    const pag = root.querySelector('.swiper-pagination');

    const autoplay = root.getAttribute('data-autoplay') === 'true';
    const delay = Number(root.getAttribute('data-delay') || 4000);

    new Swiper(root, {
      loop: true,
      speed: 600,
      slidesPerView: 1,
      watchOverflow: true,
      effect: 'fade',
  fadeEffect: { crossFade: true },

      pagination: pag ? { el: pag, clickable: true } : false,

      autoplay: autoplay ? { delay, disableOnInteraction: false } : false,
    });
  };

  document.querySelectorAll('[data-mv-swiper]').forEach(init);

  // テーマエディタでの再描画対策（loadで再度呼ばれても初期化済みならreturn）
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll?.('[data-mv-swiper]')?.forEach(init);
  });
});
